<mat-form-field class="input-parent" style="width: 80px">
  <input matInput
         class="spb-flipper"
         [(ngModel)]="value().p" type="number" style="text-align: right">
  @if (showSuffix()) {
    <span matTextSuffix style="margin-left: 4px">%</span>
  }
</mat-form-field>